var _defs, _rect, _text, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg9Checklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 280",
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes check-reveal{0%,100%{stroke-dashoffset:30}60%{stroke-dashoffset:0}}\n    @keyframes item-in{0%{opacity:0;transform:translateX(-12px)}100%{opacity:1;transform:translateX(0)}}\n    @keyframes tick-circle{0%,100%{fill:#0a1628;stroke:#1e293b}60%{fill:#052e16;stroke:#34d399}}\n    @keyframes item-text{0%,100%{fill:#1e293b}60%{fill:#e2e8f0}}\n    .row1{animation:item-in .5s ease-out .2s both}\n    .row2{animation:item-in .5s ease-out .6s both}\n    .row3{animation:item-in .5s ease-out 1s both}\n    .row4{animation:item-in .5s ease-out 1.4s both}\n    .ck1{animation:check-reveal 3s ease-in-out infinite .8s;stroke-dasharray:30}\n    .ck2{animation:check-reveal 3s ease-in-out infinite 1.4s;stroke-dasharray:30}\n    .ck3{animation:check-reveal 3s ease-in-out infinite 2s;stroke-dasharray:30}\n    .ck4{animation:check-reveal 3s ease-in-out infinite 2.6s;stroke-dasharray:30}\n    .cb1{animation:tick-circle 3s ease-in-out infinite .8s}\n    .cb2{animation:tick-circle 3s ease-in-out infinite 1.4s}\n    .cb3{animation:tick-circle 3s ease-in-out infinite 2s}\n    .cb4{animation:tick-circle 3s ease-in-out infinite 2.6s}\n    .ct1{animation:item-text 3s ease-in-out infinite .8s}\n    .ct2{animation:item-text 3s ease-in-out infinite 1.4s}\n    .ct3{animation:item-text 3s ease-in-out infinite 2s}\n    .ct4{animation:item-text 3s ease-in-out infinite 2.6s}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06091a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cl-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "url(#cl-bg)",
    rx: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 30,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "IMPLEMENTATION CHECKLIST")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "row1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 520,
    height: 50,
    rx: 10,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cb1",
    cx: 80,
    cy: 80,
    r: 18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ck1",
    points: "71,80 78,87 90,73",
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 75,
    className: "ct1",
    fontFamily: "JetBrains Mono",
    fontSize: 11,
    fontWeight: 700
  }, "Handle users with no history"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 92,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Default to 9am \u2014 build pattern from day one, refine after 14 days"), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 66,
    width: 56,
    height: 18,
    rx: 6,
    fill: "#052e16",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: ".8s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 518,
    y: 79,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: ".8s"
  }), "DONE"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "row2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 118,
    width: 520,
    height: 50,
    rx: 10,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cb2",
    cx: 80,
    cy: 143,
    r: 18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ck2",
    points: "71,143 78,150 90,136",
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 138,
    className: "ct2",
    fontFamily: "JetBrains Mono",
    fontSize: 11,
    fontWeight: 700
  }, "Respect user time zones"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 155,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Store and compare peak hour in local time \u2014 never UTC raw"), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 130,
    width: 56,
    height: 18,
    rx: 6,
    fill: "#052e16",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.4s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 518,
    y: 143,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.4s"
  }), "DONE"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "row3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 181,
    width: 520,
    height: 50,
    rx: 10,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cb3",
    cx: 80,
    cy: 206,
    r: 18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ck3",
    points: "71,206 78,213 90,199",
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 201,
    className: "ct3",
    fontFamily: "JetBrains Mono",
    fontSize: 11,
    fontWeight: 700
  }, "Prevent over-notification"), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 218,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Skip if user active in last 24h or stats show nothing to flag"), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 193,
    width: 56,
    height: 18,
    rx: 6,
    fill: "#052e16",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 518,
    y: 206,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.2;.3;.4;.8;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "2s"
  }), "DONE"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "row4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 244,
    width: 520,
    height: 20,
    rx: 8,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cb4",
    cx: 80,
    cy: 253,
    r: 7,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ck4",
    points: "76,253 79,256 85,249",
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 258,
    className: "ct4",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Track delivery, opens, and engagement to refine the model over time"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg9Checklist);
export default __webpack_public_path__ + "static/media/svg9-checklist.17d598d9db5f7d80d1ab2a5cfbfd67a0.svg";
export { ForwardRef as ReactComponent };